<template>
  <div>
    <!-- 返回顶部 -->
    <!-- <BackTop class="mb-5">
            <v-btn color="primary" small fab dark>
                <v-icon >keyboard_arrow_up</v-icon>
            </v-btn>
    </BackTop>-->
    <v-toolbar class="Vuely-toolbar" :width="250" fixed app>
      <div class="d-custom-flex align-items-center navbar-left">
        <div class="d-custom-flex ml-0 align-items-center pl-0">
          <!--  Logo  -->
          <div class="pointer mr-4">
            <a :href="domainName">
              <app-logo></app-logo>
            </a>
          </div>
          <!--  Cheat Alerts  -->
          <v-menu
            offset-y
            origin="left top"
            z-index="99"
            class="quciklink-dropdown"
            content-class="quciklink-dropdown"
            transition="slide-y-transition"
            nudge-left="30"
            fixed
          >
            <div slot="activator" class="m-0 fw-500">{{$t("right.hotTopics")}}</div>
            <v-icon slot="activator" color="primary">keyboard_arrow_down</v-icon>
            <div class="dropdown-content">
              <v-list class="dropdown-list">
                <v-list-tile class="pointer">
                  <span class="fw-bold font-1x primary--text">{{$t('right.sort')}}</span>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile class="pointer" @click="fingByHot">
                  <span class="font-15 fw-400 pointer">
                    <v-icon>whatshot</v-icon>
                    <span class="ml-3">{{$t('right.hot')}}</span>
                  </span>
                </v-list-tile>
                <v-list-tile class="pointer" @click="fingByNew">
                  <span class="font-15 fw-400 pointer">
                    <v-icon>fiber_new</v-icon>
                    <span class="ml-3">{{$t('right.new')}}</span>
                  </span>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile class="pointer">
                  <span class="fw-bold font-1x primary--text">{{$t("right.hotTopics")}}</span>
                </v-list-tile>
                <v-list-tile
                  class="pointer"
                  v-for="market in marketsList"
                  :key="market.marketId"
                  @click="findByMarkets(market)"
                >
                  <span class="font-15 fw-400 pointer">
                    <v-icon size="20">{{market.icon}}</v-icon>
                    <span class="ml-3">{{market.name}}</span>
                  </span>
                </v-list-tile>
                <v-list-tile class="pointer" @click="findByTelegramList">
                  <span class="font-15 fw-400 pointer">
                    <v-icon>fab fa-telegram</v-icon>
                    <span class="ml-3">IOB Telegram</span>
                  </span>
                </v-list-tile>
              </v-list>
            </div>
          </v-menu>
          <div class="ml-4 upgrade-btn pointer" @click="goIobots">ioBots</div>
          <div class="ml-4 upgrade-btn pointer" @click="goIobfi">iob.fi</div>
        </div>
      </div>
      <!-- Search 搜索按钮 -->
      <!-- <div class="d-custom-flex navbar-center">
        <v-text-field
          class="enter-search search-bar"
          solo
          v-model="searchText"
          prepend-inner-icon="search"
          :placeholder="$t('header.searchPlaceholder')"
        ></v-text-field>
      </div>-->
      <!-- Navbar Right -->

       
      <div class="navbar-right v-breadcrumbs__item">
         <!-- <span>
          <v-menu offset-y origin="left top" z-index="99" content-class="search-dropdown" transition="slide-y-transition" nudge-top="-10" nudge-left="30" :close-on-content-click="false">
            <v-btn icon slot="activator" class="ma-0">
                <v-icon color="primary">search</v-icon>
            </v-btn>
            <div class="dropdown-content">
              <v-list class="dropdown-list">
              <v-list-tile class="ml-1">
                <v-text-field
                append-icon="search"
                v-model="searchText"
                :placeholder="$t('header.searchPlaceholder')"
                @click:append="mobileSearch"
                @keyup.enter="mobileSearch"
              ></v-text-field>
              </v-list-tile>
              <v-list>
             
                <div v-if="this.searchHistories.length > 0" class="ma-1">
                <Tag v-for="(searchHistory, index) in searchHistories" :key="index" type="border" class="font-14 ml-2 mr-2">
                  <span @click="searchHistoryBtn(searchHistory)">{{searchHistory}}</span>
                </Tag>
              </div> 
            </v-list>
            </v-list>
            </div>
          </v-menu>
        </span> -->
        <!-- search -->
       <!--  <v-btn
          class="notification-dropdown ma-0 mr-2 pointer"
          flat
          icon
          small
          @click="showMobileSearchModal"
        >
          <Tooltip :content="$t('common.search')" placement="bottom">
            <v-icon color="primary">search</v-icon>
          </Tooltip>
        </v-btn> -->
        <!-- NewTopic -->
        <v-btn icon class="full-screen ma-0 mr-2 pointer" @click="gotoNewsTopic">
          <Tooltip :content="$t('right.industryNews')" placement="bottom">
            <v-icon color="primary">fas fa-poll-h</v-icon>
          </Tooltip>
        </v-btn>
        <!-- fingByHot -->
        <v-btn icon class="full-screen ma-0 mr-2 pointer" @click="fingByHot">
          <Tooltip :content="$t('header.hot')" placement="bottom">
            <v-icon color="primary">trending_up</v-icon>
          </Tooltip>
        </v-btn>
        <!--  fingByNew-->
        <v-btn icon class="full-screen ma-0 pointer" @click="fingByNew">
          <Tooltip :content="$t('header.new')" placement="bottom">
            <v-icon color="primary">equalizer</v-icon>
          </Tooltip>
        </v-btn>
        <!-- apps  -->
        <span>
          <v-menu
            offset-y
            origin="left top"
            z-index="99"
            content-class="notification-dropdown"
            transition="slide-y-transition"
            nudge-top="-10"
            nudge-left="30"
          >
            <v-btn icon slot="activator" class="ma-0">
              <Tooltip :content="$t('header.menu')" placement="bottom">
                <v-icon color="primary">apps</v-icon>
              </Tooltip>
            </v-btn>
            <div class="dropdown-content">
              <v-list class="dropdown-list">
                <v-list-tile class="pl-3 mb-2 mt-2 pointer" v-html="$t('foot.title')"></v-list-tile>
                <!-- 横线 -->
                <v-divider></v-divider>
                <v-list-tile
                  class="pointer"
                  v-for="text in texts"
                  :key="text.name"
                  @click="routerPage(text.code)"
                >
                  <span class="font-16">{{$t(text.name)}}</span>
                </v-list-tile>
                <!-- 横线 -->
                <v-divider></v-divider>
                <v-list-tile class="mt-1">
                  <span class="font-10">IOB LLC &copy; 2019. {{$t('foot.aLLRightsReserved')}}</span>
                </v-list-tile>
              </v-list>
            </div>
          </v-menu>
        </span>
        <v-badge overlap class="notification-dropdown ma-0 pointer font-12">
          <template v-slot:badge>
            <span v-if="notificationNum > 0">{{ notificationNum }}</span>
          </template>
          <v-btn icon @click="gotoNotification">
            <Tooltip :content="$t('header.notifications')" placement="bottom">
              <v-icon color="primary">far fa-bell</v-icon>
            </Tooltip>
          </v-btn>
        </v-badge>
        <!--  <v-btn v-show="isLogin" icon slot="activator" class="ma-0" @click="showMenuSidebar">
          <img class="img-responsive rounded-circle user-img" :alt="userName" v-bind:src="this.$store.state.user.image">
          <span>L</span>
        </v-btn>-->
        <v-btn icon v-show="isLogin" slot="activator" class="ma-0" @click="showMenuSidebar">
          <v-avatar color="primary" size="30">
            <img v-if="user != null && user.image != null" :src="user.image" :alt="user.userName" />
            <span
              v-else
              class="headline white--text"
            >{{ user != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '' }}</span>
          </v-avatar>
        </v-btn>
        <v-btn v-show="!isLogin" icon slot="activator" class="ma-0" @click="showMenuSidebar">
          <v-icon color="primary" title="User">fas fa-user-circle</v-icon>
        </v-btn>
      </div>
    </v-toolbar>
    <!-- 菜单侧边栏 -->
    <v-navigation-drawer
      hide-overlay
      fixed
      right
      temporary
      v-model="isShowMenuSidebar"
      class="Vuely-sidebar"
    >
      <app-menu></app-menu>
    </v-navigation-drawer>
    <!--用户搜索侧边栏div-->
    <v-navigation-drawer
      hide-overlay
      fixed
      right
      temporary
      v-model="isShowUserSearchSidebar"
      class="chat-sidebar-wrap"
    >
      <app-user-search></app-user-search>
    </v-navigation-drawer>
    <v-bottom-sheet v-model="isShowCookieStatement" hide-overlay persistent>
      <v-card class="text-center">
        {{$t("header.cookieStatementMessage")}}
        <a @click="goPrivacy">{{$t("header.privacyPolicy")}}</a>
        {{$t("common.punctuation.period")}}
        <v-btn outline flat small @click="dissmissCookieStatement">{{$t("header.dismiss")}}</v-btn>
      </v-card>
    </v-bottom-sheet>
    <!--Login-->
    <v-dialog v-model="this.$store.state.loginModal" max-width="500px" persistent>
      <v-card align="center">
        <v-card-title primary-title>
          <v-spacer></v-spacer>
          <h2 class="fw-bold">{{$t("header.login")}}</h2>
          <v-spacer></v-spacer>
          <v-btn flat icon right color="pink" @click="hideLoginModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md12>
                <v-form ref="formInline" lazy-validation>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      v-model="formInline.userName"
                      :label="$t('header.usernameHint')"
                      :rules="userNameRules"
                      @on-enter="loginAuth_v2"
                      class="enter-login"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      v-model="formInline.passWord"
                      :label="$t('header.passwordHint')"
                      :rules="passWordRules"
                      :type="isShowPassword ? 'text' : 'password'"
                      :append-icon="isShowPassword ? 'visibility_off' : 'visibility'"
                      class="enter-login"
                      @click:append="isShowPassword = !isShowPassword"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox color="primary" v-model="isSaveUser">
                      <div slot="label" class="ml-2">
                        {{$t('header.rememberMe')}}
                        <span
                          color="primary--text"
                          right
                          @click="goPassword"
                        >
                          <span class="ml-5">{{$t("header.forgotPassword")}}</span>?
                        </span>
                      </div>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-btn
                      block
                      class="primary"
                      :loading="loading"
                      dark
                      @click="loginAuth_v2"
                    >{{$t("header.login")}}</v-btn>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-flex style="height: 30px;">
          <span class="caption">{{$t("header.accountHint")}}?</span>
          <span class="caption primary--text pointer" @click="gotoRegister">{{$t("header.signUp")}}</span>
        </v-flex>
      </v-card>
    </v-dialog>
  <!--   <v-dialog v-model="isShowMobileSearchModal" full-width hide-overlay>
      <v-card align="center" class="pa-5">
        <v-text-field
          append-icon="search"
          v-model="searchText"
          :placeholder="$t('header.searchPlaceholder')"
          class="mx-3"
          box
          @click:append="mobileSearch"
          @keyup.enter="mobileSearch"
        ></v-text-field>
      </v-card>
    </v-dialog> -->
    <div align="center">
      <Modal
        v-model="loginAuthenticationModal"
        align="center"
        :loading="authLoading"
        :mask-closable="false"
      >
        <p
          slot="header"
          style="font-family: Helvetica-Bold; color:#333333;font-size:20px;letter-spacing: 0;line-height: 30px;height: 40px;"
        >{{$t("header.googleModalTitle")}}</p>
        <label class="font-1x">{{$t("header.googleModalEnterHint")}}</label>
        <v-form ref="formAuthentication" class="mt-4 mb-4">
          <v-flex xs4 sm2>
            <v-text-field
              v-model="formAuthentication.randomCode"
              :counter="6"
              :rules="randomCodeRules"
              single-line
              outline
              class="enter-code-login"
            ></v-text-field>
          </v-flex>
          <v-text-field
            v-show="false"
            v-model="formAuthentication.authenticationSecret"
            disabled
            required
          ></v-text-field>
        </v-form>
        <label class="font-1x">{{$t("header.googleModalContactHintBefore")}}</label>
        <label
          class="font-1x primary--text pointer"
          @click="goLostGoogleAuthentication"
        >{{$t("header.googleModalContactHintMiddle")}}</label>
        <label class="font-1x">{{$t("header.googleModalContactHintAfter")}}</label>
        <div slot="footer" align="center">
          <Button class="primary" @click="modalCancel">
            <span class="white--text">{{$t("common.cancel")}}</span>
          </Button>
          <Button class="primary" @click="verityRandomCode('formAuthentication')">
            <span class="white--text">{{$t("common.verify")}}</span>
          </Button>
        </div>
      </Modal>
    </div>
    <!-- <div class="mt-70">
      <v-layout row wrap class="mb-3" v-if="!isLogin">
        <v-flex xs12 md12 lg12>
          <v-card class="primary pa-5" dark>
            <v-layout align-center justify-center row>
              <v-flex xs12 sm12 md7 lg7 xl8>
                <h2 class="font-36 fw-400">{{$t('header.analyst')}}</h2>
                <span class="font-18 fw-400 mt-3" v-html="$t('header.paidTitle')"></span>
                <span class="font-18 fw-400 mt-3">{{$t('header.signTitle')}}</span>
                  <span class="mt-3">
                    <v-btn small color="white" class="black--text" @click="gotoRegister">{{$t('register.signUp')}}</v-btn>
                  </span>
              </v-flex>

              <v-flex xs12 sm6 md5 lg4 xl3>
                <img width="304" src="../../static/img/573x512.png" >
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </div>-->
    <!-- <v-layout row wrap class="mb-3" v-if="!isLogin">
  <v-flex xs12 md12 lg12>
    <v-card class="primary pa-5" dark>
    </v-card>
    </v-layout>-->
    <!-- <div class="mt-70">
   <v-layout row wrap class="mb-3" v-if="!isLogin">
    <v-flex xs12 md12 lg12>
     <v-card class="primary pa-5" dark>
      <v-layout justify-center >
       <v-flex lg2></v-flex>
       <v-flex>
        <h2 class="font-36 fw-400">{{$t('header.analyst')}}</h2>
        <span class="font-18 fw-400 mt-3" v-html="$t('header.paidTitle')"></span>
        <span class="font-18 fw-400 mt-3">{{$t('header.signTitle')}}</span>
          <span class="mt-3">
           <v-btn small color="white" class="black--text" @click="gotoRegister">{{$t('register.signUp')}}</v-btn>
          </span>
       </v-flex>

        <img width="304" src="../../static/img/573x512.png" >
       </v-flex>
      </v-layout>
     </v-card>
    </v-flex>
   </v-layout>
    </div>-->
    <!--向左滚动代码-->
    <!--     <v-card class="elevation-0">
      <table width="100%" border="0" cellspacing="0" cellpadding="0" class="mt-5 pa-2 text-xs-center font-14">
          <span v-for="msg in bulletinBoardData" class="ml-5 mr-5">{{ $t(msg.before) + msg.data + $t(msg.after) }}</span>
      </table>
    </v-card>
    -->
    <div class="welcomeWrapper mb-2" v-if="!isLogin">
      <div class="welcomeBanner">
        <div class="row primary">
          <div class="text-center welcomeImage small-12 show-for-small-only">
            <img class="heroImage" src="../../static/img/573x512.png" />
          </div>
          <div class="row">
            <div class="show-for-large"></div>
            <div class="small-12 medium-6 welcomePitch">
              <h2>{{$t('header.analyst')}}</h2>
              <h4 v-html="$t('header.paidTitle')"></h4>
              <v-btn
                small
                color="white"
                class="black--text pa-0"
                @click="gotoRegister"
              >{{$t('register.signUp')}}</v-btn>
            </div>
            <div class="text-center welcomeImage medium-6 show-for-medium">
              <img class="heroImage" src="../../static/img/573x512.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped="scoped">
.v-menu__content {
  position: fixed !important;
  top: 45px !important;
}
.v-text-field--box input,
.v-text-field--full-width input,
.v-text-field--outline input {
  margin-top: 16px !important;
}
</style>
<script>
/* eslint-disable */
import Vue from "vue";
import Md5 from "js-md5";
import config from "../config.js";
import { mapGetters } from "vuex";
import { eventBus } from "../assets/js/eventBus.js";
export default {
  data() {
    const validateAuthenticationSecret = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("The Authentication Secret Key cannot be empty"));
      } else {
        callback();
      }
    };
    const validateRandomCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("The Random Code cannot be empty"));
      } else if (!Number.isInteger(+value)) {
        callback(new Error("Please enter a numeric value"));
      } else if ((value + "").length !== 6) {
        callback(new Error("Must be 6 digits"));
      } else {
        callback();
      }
    };
    return {
      texts: [
        { name: "foot.aboutUs", code: "aboutus" },
        { name: "foot.contact", code: "contact" },
        { name: "foot.gdpr", code: "gdpr" },
        { name: "foot.privacy", code: "privacy" },
        { name: "foot.policy", code: "policy" },
        { name: "foot.contentpolicy", code: "contentpolicy" },
        { name: "foot.kyc", code: "kyc" }
        // { name: "foot.IOBToken", code: "iobtoken" }
      ],
      isShowMenuSidebar: false, //是否显示菜单侧边栏
      languageName: "",
      languageModel: "",
      language: true,
      showOrderMenu: false,
      isTCSLogin: false,
      isOrderLogin: false,
      //多语言: name-页面显示的文字;code-语言代码;
      languages: [
        {
          code: "en-US",
          name: "English(United States)",
          img: "../../public/static/image/flag-icons/zh.png"
        },
        {
          code: "zh-CN",
          name: "简体中文",
          img: "../../public/static/image/flag-icons/en.png"
        }
      ],
      domainName: config.ip,
      chatSidebar: false, // chat component right sidebar
      isShowSearchInput: false, //是否显示搜索的输入框
      searchText: null, //搜索文本
      isShowUserControl: false, //是否显示用户的管理菜单
      isSaveUser: false, //是否保存用户信息
      loading: false, //登录按钮的加载状态
      loginAuthenticationModal: false, //登录时二级认证的modal框
      authLoading: true, //认证加载中状态
      isShowMenuSidebar: false, //是否显示菜单侧边栏
      isShowUserSearchSidebar: false, //是否显示用户搜索侧边栏
      isShowPassword: false, //是否显示密码
      isShowMobileSearchModal: false, // 是否显示手机搜索弹出
      //是否显示使用cookies消息，null为显示，false为不显示
      isShowCookieStatement:
        localStorage.getItem("SIP-isShowCookieStatement") == null,
      userId: {
        //二次认证时候的id
        id: ""
      },
      formInline: {
        //登录表单
        userName: "",
        passWord: ""
      },
      userNameRules: [
        //用户名认证规则
        v => !!v || this.$t("header.usernameHintEmpty")
      ],
      passWordRules: [
        //密码认证规则
        v => !!v || this.$t("header.passwordHintEmpty"),
        v => (v && v.length >= 8) || this.$t("header.passwordHintLength")
      ],
      randomCodeRules: [
        //Google随机码规则
        v => !!v || "",
        v => (v && v.length == 6) || "",
        v => /^\d{6}$/.test(v) || ""
      ],
      formAuthentication: {
        //认证表单
        authenticationSecret: "",
        randomCode: ""
      },
      ruleAuthentication: {
        authenticationSecret: [
          { validator: validateAuthenticationSecret, trigger: "blur" }
        ],
        randomCode: [{ validator: validateRandomCode, trigger: "blur" }]
      },
      bulletinBoardData: [
        {
          before: "header.announcement.total",
          data: 0,
          after: "header.announcement.usersAwardMsg"
        },
        {
          before: "header.announcement.total",
          data: 0,
          after: "header.announcement.postsAwardMsg"
        }
      ],
      // 搜索历史
      searchHistories:[],
    };
  },
  props: {
    source: String
  },
  computed: {
    ...mapGetters(["user", "marketsList", "notificationNum"]),
    isLogin() {
      if (
        this.$store.state.user.token != null &&
        this.$store.state.user.token != ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {},
  mounted() {
    if(JSON.parse(localStorage.getItem("SIP-searchHistories"))){
      this.searchHistories = JSON.parse(localStorage.getItem("SIP-searchHistories"));
    }
    // 获取登录表单数据
    this.getLoginFromData();
    //获取公告栏的数据
    // this.getBulletinBoardData();
    //检测是否显示用户搜索侧边栏
    eventBus.$on("isShowUserSearchSidebar", data => {
      this.isShowUserSearchSidebar = data;
    });
    //回车登录事件
    $(document).on("keypress", ".enter-login", event => {
      if (event.keyCode == 13) {
        this.loginAuth_v2();
      }
    });
    //回车搜索事件
    $(document).on("keypress", ".enter-search", event => {
      if (event.keyCode == 13) {
        this.search();
      }
    });
    //回车提交验证码
    $(document).on("keypress", ".enter-code-login", event => {
      if (event.keyCode == 13) {
        this.verityRandomCode("formAuthentication");
      }
    });
  },
  watch: {},
  methods: {
    goPrivacy() {
      this.$router.push({ name: "privacy" });
    },
    dissmissCookieStatement() {
      this.isShowCookieStatement = false;
      localStorage.setItem("SIP-isShowCookieStatement", 0);
    },
    //路由跳转页面
    routerPage(code) {
      switch (code) {
        case "aboutus":
          this.$router.push({ name: "about" });
          break;
        // case "contact":
        //   window.open("https://iob.llc/about/contact-us/", "_blank");
        //   break;
        case "contact":
          this.$router.push({ name: "contact" });
          break;
        case "gdpr":
          this.$router.push({ name: "GDPR" });
          break;
        case "privacy":
          this.$router.push({ name: "privacy" });
          break;
        case "policy":
          this.$router.push({ name: "AML" });
          break;
        case "kyc":
          this.$router.push({ name: "KYC" });
          break;
        case "contentpolicy":
          this.$router.push({ name: "ContentPolicy" });
          break;
        case "iobots":
          window.open("https://iobots.pro/signals", "_blank");

        // case "iobtoken":
        //   window.open("https://iob.llc/about/faq/faq-iob-token-eco/", "_blank");
        //   break;
        default:
          break;
      }
    },
    //获取公告栏的数据
    // getBulletinBoardData() {
    //   let userApi = config.baseUrl + 'userDetail/open/count/totalAwardedIOBPower'
    //   this.$http.get(userApi).then(response => {
    //     this.bulletinBoardData[0].data = response.data.result.toFixed(2);
    //   });
    //   let postApi = config.baseUrl + 'posting/open/count/totalAwardedIOBPower'
    //   this.$http.get(postApi).then(response => {
    //     this.bulletinBoardData[1].data = response.data.result.toFixed(2);
    //   });
    // },
    //查看telegram消息
    findByTelegramList() {
      if (this.$store.state.user.token == null) {
        this.$store.state.loginModal = true;
      } else {
        this.$router.push({ name: "telegramusermessages" });
      }
    },
    // 跳转到通知页面
    gotoNotification() {
      if (this.$store.state.user.token) {
        this.$router.push({ name: "notification" });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //最热排序
    fingByHot() {
      //Posts
      this.$router.push({ name: "posts" });
      this.$store.dispatch("pageTitleHandler", "hot");
    },
    //最新排序
    fingByNew() {
      //Posts
      this.$router.push({ name: "posts" });
      this.$store.dispatch("pageTitleHandler", "new");
    },
    //根据id查看市场详情
    findByMarkets(market) {
      localStorage.setItem("SIP-marketsCode", market.code);
      localStorage.setItem("SIP-marketsTitle", market.name);
      this.$store.dispatch("marketsDescHandler", market.description);
      this.$router.push({
        name: "marketPosts",
        params: {
          marketsName: market.name
        }
      });
    },
    //发帖
    postingcreate() {
      if (localStorage.getItem("token")) {
        this.$router.push({ name: "createPost" });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //搜索
    search() {
      if (this.searchText != null && this.searchText.trim() != "") {
        let searchHistoryArray =  JSON.parse(localStorage.getItem("SIP-searchHistories"));
        if(searchHistoryArray){
          this.searchHistories = searchHistoryArray
        }
        this.searchHistories.unshift(this.searchText)
        this.searchHistories = this.uniquel(this.searchHistories)
        if( this.searchHistories.length >10 ){
          this.searchHistories = this.searchHistories.slice(0,10)
        }
        localStorage.setItem("SIP-searchHistories",JSON.stringify(this.searchHistories)) 
        this.$store.dispatch("searchTextHandler", this.searchText.trim());
        this.$router.push({
          name: "searchPosts",
          params: { searchText: this.searchText }
        });
        // this.searchText = null;
      }
      this.searchText = null;
    },
    // 点击搜索历史
    searchHistoryBtn(searchHistory){
      this.searchText = searchHistory;
      this.search();
    },
    //显示菜单侧边栏
    showMenuSidebar() {
      this.isShowMenuSidebar = !this.isShowMenuSidebar;
    },
    isshowOrderMenu() {
      if (this.showOrderMenu == false) {
        this.showOrderMenu = true;
      } else {
        this.showOrderMenu = false;
      }
    },
    //显示登录模态框
    showLoginModal() {
      this.$store.state.loginModal = true;
    },
    //隐藏登录模态框
    hideLoginModal() {
      this.$store.state.loginModal = false;
      setTimeout(() => {
        // localStorage.clear();
        localStorage.removeItem("SIP-user");
        localStorage.removeItem("SIP-role");
        localStorage.removeItem("userName");
        localStorage.removeItem("id");
        localStorage.removeItem("token");
        localStorage.removeItem("image");
        localStorage.removeItem("invitationCode");
        this.$store.state.user.id = null;
        this.$store.state.user.name = null;
        this.$store.state.user.token = null;
        this.$store.state.user.image = null;
      }, 100);
    },
    //关闭认证模态框
    modalCancel() {
      this.loginAuthenticationModal = false;
    },
    //读取cookie
    getCookie() {
      if (document.cookie.length > 0) {
        let arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "user") {
            //给输入框添值
            this.formInline.userName = arr2[1];
            if (arr2[1] !== null && "" !== arr2[1]) {
              this.isSaveUser = true;
            }
          }
          if (arr2[0] == "password") {
            //给输入框添值
            this.formInline.passWord = arr2[1];
            if (arr2[1] !== null && "" !== arr2[1]) {
              this.isSaveUser = true;
            }
          }
        }
      }
    },
    // 获取登录表单数据
    getLoginFromData() {
      var isSaveUser = localStorage.getItem("SIP-loginIsSaveUser");
      if (isSaveUser == 1) {
        this.isSaveUser = true;
        this.formInline.userName = localStorage.getItem("SIP-loginUsername");
        this.formInline.passWord = localStorage.getItem("SIP-loginPassword");
      }
    },
    gotoHome() {
      this.$router.push({ name: "posts" });
      this.$router.go();
    },

    goIobots() {
      window.open("https://iobots.pro/", "_blank");
    },
    goIobfi() {
      window.open("https://iob.fi/", "_blank");
    },
    /**************************************/
    gotoIOBLLC() {},
    gotoNewsTopic() {
      this.$router.push({
        name: "marketPosts",
        params: {
          marketsName: "Industry News"
        }
      });
    },
    //找回密码
    goPassword() {
      this.$store.state.loginModal = false;
      this.$router.push({ name: "password" });
    },
    gotoRegister() {
      this.$store.state.loginModal = false;
      this.$router.push({ name: "register" });
    },
    goLostGoogleAuthentication() {
      this.loginAuthenticationModal = false;
      this.$router.push({ name: "lostGoogleAuthentication" });
    },
    goUserRequest() {
      this.loginAuthenticationModal = false;
      this.$router.push({ name: "userRequest" });
    },
    showMobileSearchModal() {
      this.isShowMobileSearchModal = true;
    },
    mobileSearch() {
      this.isShowMobileSearchModal = false;
      this.search();
    },
    // 数组去重
    uniquel(arr){
      var hash=[];
      for (var i = 0; i < arr.length; i++) {
        if(hash.indexOf(arr[i])==-1){
          hash.push(arr[i]);
        }
      }
      return hash;
    },
    //设置cookie
    setCookieUser(c_user, severalDays) {
      let currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + 24 * severalDays);
      //字符串拼接cookie
      window.document.cookie =
        "user" + "=" + c_user + ";path=/;expires=" + currentDate.toGMTString();
    },
    //设置cookie
    setCookiePassword(c_password, severalDays) {
      let currentDate = new Date();
      //对密码多层加密
      currentDate.setHours(currentDate.getHours() + 24 * severalDays);
      //字符串拼接cookie
      window.document.cookie =
        "password" +
        "=" +
        c_password +
        ";path=/;expires=" +
        currentDate.toGMTString();
    },
    //登录请求
    loginAuth() {
      if (this.$refs.formInline.validate()) {
        //校验成功后，发送登录请求
        this.loading = true;
        let url = config.baseUrl + "user/open/loginPost";
        //判断复选框是否被勾选 勾选则调用配置cookie方法
        //字符串逆序：c_password.split('').reverse().join('');
        var flag = true;
        if (document.cookie.length > 0) {
          let arr = document.cookie.split("; ");
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split("="); //再次切割
            if (arr2[0] == "password") {
              //给输入框添值
              var cookiePassword = arr2[1];
              if (this.formInline.passWord == cookiePassword) {
                //是cookie的密码
                this.formInline.passWord = Md5(cookiePassword);
                flag = false;
              }
            }
          }
        }
        if (flag) {
          var password = Md5(this.formInline.passWord);
          var password = password
            .split("")
            .reverse()
            .join("");
          this.formInline.passWord = Md5(password);
        }
        this.$http.post(url, this.formInline).then(
          function(successData) {
            let data = successData.data;
            if (data.resCode == 0) {
              //登录成功
              // console.log(data.result.token);
              if (this.isSaveUser) {
                //保存正确的登录名和密码
                //365天 * 10 = 3650天 = 10年
                //保存十年,时间够久了，就算不清除数据，十年后电脑都成骨灰了
                //传入账号名
                this.setCookieUser(this.formInline.userName, 3650);
                //传入密码
                if (flag) {
                  this.setCookiePassword(password, 3650);
                } else {
                  this.setCookiePassword(cookiePassword, 3650);
                }
              } else {
                //时间为-1天，就会自动失效
                this.setCookieUser("", -1);
                this.setCookiePassword("", -1);
              }
              var userDto = data.result;
              this.$store.state.user.name = userDto.userName;
              this.$store.state.user.token = userDto.token;
              this.$store.state.user.id = userDto.id;
              this.$store.state.user.image = userDto.image;
              localStorage.setItem("userName", userDto.userName);
              localStorage.setItem("id", userDto.id);
              localStorage.setItem("token", userDto.token);
              localStorage.setItem("image", userDto.image);
              localStorage.setItem("invitationCode", userDto.invitationCode);
              this.$store.dispatch("localeHandler", userDto.i18n.code);
              Vue.http.interceptors.push(function(request, next) {
                // 接口每次请求会跨域携带cookie
                request.credentials = true;
                // 请求headers携带参数
                request.headers.set(
                  "Authorization",
                  "Bearer " + data.result.token
                );
                next();
              });
              this.$refs.formInline.reset();
              this.loading = false;
              this.$store.state.loginModal = false;
              // this.$router.go();
            } else if (data.resCode == -1000) {
              this.$Message.error(this.$t("header.userNotExistMessage"));
              this.loading = false;
            } else if (data.resCode == -1001) {
              this.$Message.error(this.$t("header.passwordWrongMessage"));
              this.loading = false;
            } else if (data.resCode == -1004) {
              this.$Message.error(this.$t("header.accountDisableMessage"));
              this.loading = false;
            } else if (data.resCode == -1005) {
              if (this.isSaveUser) {
                //保存正确的登录名和密码
                //365天 * 10 = 3650天 = 10年
                //保存十年,时间够久了，就算不清除数据，十年后电脑都成骨灰了
                //传入账号名
                this.setCookieUser(this.formInline.userName, 3650);
                //传入密码
                if (flag) {
                  this.setCookiePassword(password, 3650);
                } else {
                  this.setCookiePassword(cookiePassword, 3650);
                }
              } else {
                //时间为-1天，就会自动失效
                this.setCookieUser("", -1);
                this.setCookiePassword("", -1);
              }
              this.userId.id = data.result.id;
              this.formAuthentication.authenticationSecret =
                data.result.authenticationSecret;
              this.loading = false;
              this.$store.state.loginModal = false;
              this.loginAuthenticationModal = true;
            }
          },
          function(errorData) {
            this.loading = false;
          }
        );
      }
    },
    // 第二版本密码认证
    loginAuth_v2() {
      if (this.$refs.formInline.validate()) {
        //校验成功后，发送登录请求
        this.loading = true;
        let url = config.baseUrl + "user/open/loginPost";
        //判断复选框是否被勾选 勾选则调用配置cookie方法
        //字符串逆序：c_password.split('').reverse().join('');
        var passWord = Md5(this.formInline.passWord);
        passWord = passWord
          .split("")
          .reverse()
          .join("");
        // 第一版本MD5密码
        passWord = Md5(passWord);
        let sha256 = require("js-sha256").sha256;
        // 第二版本sha256密码
        let possWord_v2 = sha256(this.formInline.passWord);
        const userFormData = {
          userName: this.formInline.userName,
          passWord: passWord,
          passWord_v2: possWord_v2
        };
        this.$http.post(url, userFormData).then(
          function(successData) {
            let data = successData.data;
            if (data.resCode == 0) {
              //登录成功
              if (this.isSaveUser) {
                //保存正确的登录名和密码
                localStorage.setItem("SIP-loginIsSaveUser", 1);
                localStorage.setItem(
                  "SIP-loginUsername",
                  this.formInline.userName
                );
                localStorage.setItem(
                  "SIP-loginPassword",
                  this.formInline.passWord
                );
              } else {
                localStorage.removeItem("SIP-loginIsSaveUser");
                localStorage.removeItem("SIP-loginUsername");
                localStorage.removeItem("SIP-loginPassword");
              }
              var userDto = data.result;
              this.$store.state.user.name = userDto.userName;
              this.$store.state.user.token = userDto.token;
              this.$store.state.user.id = userDto.id;
              this.$store.state.user.image = userDto.image;
              localStorage.setItem("userName", userDto.userName);
              localStorage.setItem("id", userDto.id);
              localStorage.setItem("token", userDto.token);
              localStorage.setItem("image", userDto.image);
              localStorage.setItem("invitationCode", userDto.invitationCode);
              this.$store.dispatch("localeHandler", userDto.i18n.code);
              Vue.http.interceptors.push(function(request, next) {
                // 接口每次请求会跨域携带cookie
                request.credentials = true;
                // 请求headers携带参数
                request.headers.set(
                  "Authorization",
                  "Bearer " + data.result.token
                );
                next();
              });
              this.$refs.formInline.reset();
              this.loading = false;
              this.$store.state.loginModal = false;
              this.$router.go();
            } else if (data.resCode == -1000) {
              this.$Message.error(this.$t("header.userNotExistMessage"));
              this.loading = false;
            } else if (data.resCode == -1001) {
              this.$Message.error(this.$t("header.passwordWrongMessage"));
              this.loading = false;
            } else if (data.resCode == -1004) {
              this.$Message.error(this.$t("header.accountDisableMessage"));
              this.loading = false;
            } else if (data.resCode == -1005) {
              // Google认证
              if (this.isSaveUser) {
                //保存正确的登录名和密码
                localStorage.setItem("SIP-loginIsSaveUser", 1);
                localStorage.setItem(
                  "SIP-loginUsername",
                  this.formInline.userName
                );
                localStorage.setItem(
                  "SIP-loginPassword",
                  this.formInline.passWord
                );
              } else {
                localStorage.removeItem("SIP-loginIsSaveUser");
                localStorage.removeItem("SIP-loginUsername");
                localStorage.removeItem("SIP-loginPassword");
              }
              this.userId.id = data.result.id;
              this.formAuthentication.authenticationSecret =
                data.result.authenticationSecret;
              this.loading = false;
              this.$store.state.loginModal = false;
              this.loginAuthenticationModal = true;
            }
          },
          function(errorData) {
            this.loading = false;
          }
        );
      }
    },
    //vuetify验证随机码是否正确
    verityRandomCode(name) {
      if (this.$refs[name].validate()) {
        let url = config.baseUrl + "user/open/authenticationRandomCode";
        this.$http.post(url, this.formAuthentication).then(
          successData => {
            let data = successData.data;
            if (data.result) {
              let userUrl = config.baseUrl + "user/open/userDto";
              this.$http.post(userUrl, this.userId).then(
                successData => {
                  let data = successData.data;
                  if (data.resCode == 0) {
                    this.$store.state.user.name = data.result.userName;
                    this.$store.state.user.token = data.result.token;
                    this.$store.state.user.id = data.result.id;
                    this.$store.state.user.image = data.result.image;
                    localStorage.setItem("userName", data.result.userName);
                    localStorage.setItem("id", data.result.id);
                    localStorage.setItem("token", data.result.token);
                    localStorage.setItem("image", data.result.image);
                    localStorage.setItem(
                      "invitationCode",
                      data.result.invitationCode
                    );
                    Vue.http.interceptors.push((request, next) => {
                      // 接口每次请求会跨域携带cookie
                      request.credentials = true;
                      // 请求headers携带参数
                      request.headers.set(
                        "Authorization",
                        "Bearer " + data.result.token
                      );
                      next();
                    });
                    this.authLoading = false;
                    this.$nextTick(() => {
                      this.authLoading = true;
                    });
                    this.loginAuthenticationModal = false;
                    this.$router.go();
                  }
                },
                errorData => {
                  this.authLoading = false;
                  this.$nextTick(() => {
                    this.authLoading = true;
                  });
                }
              );
            } else {
              this.$Message.error(
                this.$t("header.verificationCodeErrorMessage")
              );
              this.formAuthentication.randomCode = "";
              this.authLoading = false;
              this.$nextTick(() => {
                this.authLoading = true;
              });
            }
          },
          errorData => {
            this.authLoading = false;
            this.$nextTick(() => {
              this.authLoading = true;
            });
          }
        );
      } else {
        this.$Message.error(this.$t("header.verificationCodeErrorMessage"));
        this.formAuthentication.randomCode = "";
        this.authLoading = false;
        this.$nextTick(() => {
          this.authLoading = true;
        });
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// Header.vue?1f6f2b56